import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { InputAdornment, TextField } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { toast } from 'react-hot-toast';

type Row = {
  host: string;
  type: string;
  data: string;
};
export function DnsRecordsTable({ rows }: { rows: Row[] }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Host name</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell>
                <ReadOnlyTextField value={row.host} />
              </TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>
                <ReadOnlyTextField value={row.data} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function ReadOnlyTextField({ value }: { value: string }) {
  const handleCopy = React.useCallback(() => {
    navigator.clipboard.writeText(value);
    toast.success('Copied to clipboard');
  }, [value]);

  return (
    <TextField
      className="w-full"
      value={value}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment
            className="cursor-pointer"
            position="end"
            onClick={handleCopy}
          >
            <ContentCopy fontSize="small" color="primary"></ContentCopy>
          </InputAdornment>
        ),
      }}
    ></TextField>
  );
}
